var map = {
	"./admin": [
		8903,
		964
	],
	"./admin.tsx": [
		8903,
		964
	],
	"./crew-battle": [
		5713,
		68,
		972,
		911
	],
	"./crew-battle.tsx": [
		5713,
		68,
		972,
		911
	],
	"./odins-journal": [
		6479,
		455
	],
	"./odins-journal.tsx": [
		6479,
		455
	],
	"./odins-journal/config": [
		2098,
		925
	],
	"./odins-journal/config.tsx": [
		2098,
		925
	],
	"./settings": [
		5963,
		662
	],
	"./settings.tsx": [
		5963,
		662
	],
	"./tournament": [
		8967,
		68,
		972,
		267
	],
	"./tournament.tsx": [
		8967,
		68,
		972,
		267
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7902;
module.exports = webpackAsyncContext;